export const plans = {
  // 헤더
  title: '플랜 선택',
  subtitle: '언제든지 플랜 변경·해지가 가능합니다. 매월 25일에 다음 달분이 갱신됩니다.',

  // 무료 모드 (FREE_MODE 운영 중)
  freeTitle: '현재 무료로 이용하실 수 있습니다',
  freeDescription: '테스트 기간 중에는 모든 기능을 무료로 이용하실 수 있습니다. 결제가 필요하지 않습니다. 플랜 선택과 결제는 유료화 시점에 시작됩니다.',
  freeCta: '마이페이지로',

  // 구독 중 배너
  activeBanner: '현재 플랜이 활성화되어 있습니다. 변경하시려면 아래에서 선택하세요.',

  // 플랜 공통
  perMonthUnit: '회 / 월',
  popularBadge: '인기',
  selectButton: '이 플랜으로 하기',
  processing: '처리 중...',
  checkoutError: '체크아웃 생성에 실패했습니다',
  freeModeError: '현재 무료 모드이므로 체크아웃을 생성할 수 없습니다.',

  // 플랜 정의
  basicName: 'Basic',
  basicDesc: '월 4회 레슨. 우선 가볍게 시작하고 싶은 분께.',
  plus2Name: 'Plus 2',
  plus2Desc: '월 6회. 주 1~2회 페이스로 꾸준히 이어가고 싶은 분께.',
  plus4Name: 'Plus 4',
  plus4Desc: '월 8회. 집중적으로 실력을 키우고 싶은 분께.',

  // 보충 설명
  note1: '첫 2회는 무료(피드백 설문 조건부)',
  note2: '1회분은 다음 달로 이월 가능',
  note3: '매월 15일까지 신청하면 다음 달 해지',
  note4: '테스트 기간 중에는 특별 가격으로 이용하실 수 있습니다',
};
